import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import axios from "axios";
import { reportShipmentsReturnsTypes } from "redux/reducers/Reports/reportShipmentsReturns/types";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";

const { SET_SHIPMENTS_RETURNS_FILTERS } = reportShipmentsReturnsTypes;

export const getReportShipmentsReturnsAction = ({ startDate, endDate, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    dispatch(startRequestComp('loadingShipmentsReturns'));
    try {
      const token = getState().login.token || localStorage.getItem('crm-user');
      const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/reports/shipments-returns`;
      const fileName = `Reporte_Devoluciones_Embarques_${station.name}_${startDate}_${endDate}.${isPdf ? "pdf" : "xlsx"}`;

      const file = await axios({
        url: reportUrl,
        method: 'GET',
        responseType: 'blob',
        headers: { authorization: token },
        params: { idStation: station.id, start: startDate, end: endDate, pdf: isPdf },
      });

      saveAs(file.data, fileName);
      dispatch(setSnackbar("Reporte descargado con éxito", "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingShipmentsReturns'));
    }
  };
};

export const setReportShipmentsReturnsFilters = (key = "", value) => ({
  type: SET_SHIPMENTS_RETURNS_FILTERS,
  payload: { key, value }
});
